export function mapGeoPoint(raw) {
  if (!raw || typeof raw !== 'object') {
    return null
  }
  const lat = Number(raw.lat)
  const lng = Number(raw.lng)
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null
  }
  if (lat === 0 && lng === 0) {
    return null
  }
  return { lat, lng }
}
